import * as $runtime from "../runtime.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import {initSliderWithConfig} from "./foreign.js";
const $ResponsiveBreakpoint = tag => ({tag});
const $ResponsiveSlides = _1 => ({tag: "Slides", _1});
const encodeWithOptionsOther = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const encode1 = /* #__PURE__ */ (() => Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
  reflectSymbol: () => "type"
})(encodeWithOptionsOther))({reflectSymbol: () => "rewind"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "gap"})(encodeWithOptionsOther).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions))();
const fromFoldable = /* #__PURE__ */ Foreign$dObject.fromFoldable(Data$dFoldable.foldableArray);
const Slides = value0 => $ResponsiveSlides(value0);
const ExtraSmall = /* #__PURE__ */ $ResponsiveBreakpoint("ExtraSmall");
const Small = /* #__PURE__ */ $ResponsiveBreakpoint("Small");
const Medium = /* #__PURE__ */ $ResponsiveBreakpoint("Medium");
const ExtraMedium = /* #__PURE__ */ $ResponsiveBreakpoint("ExtraMedium");
const Large = /* #__PURE__ */ $ResponsiveBreakpoint("Large");
const ExtraLarge = /* #__PURE__ */ $ResponsiveBreakpoint("ExtraLarge");
const serializeResponsiveSlides = v => v._1;
const serializeResponsiveBreakpoint = v => {
  if (v.tag === "ExtraSmall") { return "xsmall"; }
  if (v.tag === "Small") { return "small"; }
  if (v.tag === "Medium") { return "medium"; }
  if (v.tag === "ExtraMedium") { return "extraMedium"; }
  if (v.tag === "Large") { return "large"; }
  if (v.tag === "ExtraLarge") { return "extraLarge"; }
  $runtime.fail();
};
const slider = () => () => params => {
  const $0 = {responsive: [], onVisible: v => () => {}, ...params};
  return (node, v) => {
    const $1 = {
      baseOptions: encode1({rewind: $0.rewind, type: $0.type, gap: $0.gap}),
      responsiveOptions: fromFoldable(Data$dFunctor.arrayMap(v1 => Data$dTuple.$Tuple(
        (() => {
          if (v1._1.tag === "ExtraSmall") { return "xsmall"; }
          if (v1._1.tag === "Small") { return "small"; }
          if (v1._1.tag === "Medium") { return "medium"; }
          if (v1._1.tag === "ExtraMedium") { return "extraMedium"; }
          if (v1._1.tag === "Large") { return "large"; }
          if (v1._1.tag === "ExtraLarge") { return "extraLarge"; }
          $runtime.fail();
        })(),
        v1._2._1
      ))($0.responsive)),
      onVisible: $1 => $0.onVisible($1)()
    };
    return initSliderWithConfig(node, $1);
  };
};
export {
  $ResponsiveBreakpoint,
  $ResponsiveSlides,
  ExtraLarge,
  ExtraMedium,
  ExtraSmall,
  Large,
  Medium,
  Slides,
  Small,
  encode1,
  encodeWithOptionsOther,
  fromFoldable,
  serializeResponsiveBreakpoint,
  serializeResponsiveSlides,
  slider
};
export * from "./foreign.js";
